// src/config/index.js
export const DEFAULT_REG_CHANNEL = 'genggoh5';

const configs = {
  development: {
    apiUrl: 'https://test.rental.starnetech.cn',
    //apiUrl: 'https://h5.genggo.id',
    //apiUrl: 'http://localhost:8818',
  },
  sit: {
    apiUrl: 'http://dev.rental.starnetech.cn:18080',
  },
  test: {
    apiUrl: 'https://test.rental.starnetech.cn',
    //apiUrl: 'https://h5.genggo.id',
  },
  production: {
    apiUrl: '',
  }
}

console.log('当前环境：', process.env.NODE_ENV)

// 获取当前环境配置
const env = process.env.NODE_ENV || 'development';
const currentConfig = configs[env];

export default {
  ...currentConfig,
}
